import PropTypes from 'prop-types';
import React from 'react';
import EmailCaptureLite from '../EmailCaptureLite';
import css from './EmailOnly.module.scss';
import { Copyright } from './Links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FooterEmailOnly = function FooterEmailOnly(_ref) {
  var source = _ref.source;
  return /*#__PURE__*/_jsxs("footer", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.form,
      children: /*#__PURE__*/_jsx(EmailCaptureLite, {
        source: source
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.links,
      children: [/*#__PURE__*/_jsx("a", {
        className: css.link,
        href: "/terms",
        children: "Terms of Use"
      }), /*#__PURE__*/_jsx("a", {
        className: css.link,
        href: "/privacy-policy",
        children: "Privacy"
      })]
    }), /*#__PURE__*/_jsx(Copyright, {})]
  });
};

FooterEmailOnly.propTypes = {
  source: PropTypes.string
};
FooterEmailOnly.defaultProps = {
  source: ''
};
export default FooterEmailOnly;